import { Injectable } from "@angular/core";
import {
  CompanyIndirectCompanyShareholderInput,
  CompanyIndirectIndividualShareholderInput,
  CompanyIndirectShareholderType,
  CreateCompanyIndirectCompanyShareholderMutation,
  CreateCompanyIndirectIndividualShareholderMutation,
  CreateCorporateJobMutation,
  DeleteCompanyIndirectShareholderMutation, UpdateCompanyIndirectCompanyShareholderInput,
  UpdateCompanyIndirectCompanyShareholderMutation,
  UpdateCompanyIndirectIndividualShareholderInput,
  UpdateCompanyIndirectIndividualShareholderMutation
} from "@generated/graphql";
import { CompanyIndirectShareholder } from "@modules/company/models/company-indirect-shareholder.model";
import { map, Observable } from "rxjs";
import { companyIndirectShareholderFactory } from "@modules/company/factories/company-indirect-shareholder.factory";
import { DeleteContract } from "@shared/contracts/delete.contract";
import { DateTime } from "luxon";

@Injectable({
  providedIn: 'root'
})
export class CompanyIndirectShareholderApi implements DeleteContract<string, Observable<boolean>> {
  constructor(
    private readonly createIndirectCompanyShareholderMutation: CreateCompanyIndirectCompanyShareholderMutation,
    private readonly createCompanyIndirectIndividualShareholderMutation: CreateCompanyIndirectIndividualShareholderMutation,
    private readonly updateCompanyIndirectCompanyShareholderMutation: UpdateCompanyIndirectCompanyShareholderMutation,
    private readonly updateCompanyIndirectIndividualShareholderMutation: UpdateCompanyIndirectIndividualShareholderMutation,
    private readonly deleteCompanyIndirectShareholderMutation: DeleteCompanyIndirectShareholderMutation,
  ) {
  }

  delete$(id: string): Observable<boolean> {
    return this.deleteCompanyIndirectShareholderMutation.mutate({ id }).pipe(
      map(res => res.data.deleteCompanyIndirectShareholder)
    )
  }

  createIndirectCompanyShareholder(input: CompanyIndirectCompanyShareholderInput): Observable<CompanyIndirectShareholder> {
    const valueFormat = {
      ...input,
      officerProfile: {
        ...input.officerProfile,
        registrationDate: DateTime.fromJSDate(input.officerProfile.registrationDate).toFormat('yyyy-MM-dd')
      }
    }

    return this.createIndirectCompanyShareholderMutation
      .mutate({ input: valueFormat })
      .pipe(
        map(res => companyIndirectShareholderFactory.tryCreating(res.data.createCompanyIndirectCompanyShareholder as CompanyIndirectShareholderType))
      )
  }

  createIndirectIndividualShareholder(input: CompanyIndirectIndividualShareholderInput): Observable<CompanyIndirectShareholder> {
    return this.createCompanyIndirectIndividualShareholderMutation
      .mutate({ input })
      .pipe(
        map(res => companyIndirectShareholderFactory.tryCreating(res.data.createCompanyIndirectIndividualShareholder as CompanyIndirectShareholderType))
      )
  }

  updateIndirectIndividualShareholder(input: UpdateCompanyIndirectIndividualShareholderInput): Observable<CompanyIndirectShareholder> {
    return this.updateCompanyIndirectIndividualShareholderMutation
      .mutate({ input })
      .pipe(
        map(res => companyIndirectShareholderFactory.tryCreating(res.data.updateCompanyIndirectIndividualShareholder as CompanyIndirectShareholderType))
      )
  }

  updateIndirectCompanyShareholder(input: UpdateCompanyIndirectCompanyShareholderInput): Observable<CompanyIndirectShareholder> {
    const valueFormat = {
      ...input,
      officerProfile: {
        ...input.officerProfile,
        registrationDate: DateTime.fromJSDate(input.officerProfile.registrationDate).toFormat('yyyy-MM-dd')
      }
    }
    return this.updateCompanyIndirectCompanyShareholderMutation
      .mutate({ input: valueFormat })
      .pipe(
        map(res => companyIndirectShareholderFactory.tryCreating(res.data.updateCompanyIndirectCompanyShareholder as CompanyIndirectShareholderType))
      )
  }
}
